// extracted by mini-css-extract-plugin
export default {"row":"eK_WUmASMKH2NbGEkZq0","column":"nW8ZZGxvry7qJXUzeHBL","moduleFormBlock":"nBQ5AyXt5qqdvcgf9plL"};